import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import debounce from 'lodash/debounce'
import cookies from 'js-cookie'

import config from '../../config'
import moment from 'moment'

import Pagination from '../pagination'

import { setModal } from '../../actions/modal'

class SubscriptionsListComponent extends Component {
  constructor(props){
    super(props)

    this.state = {
      subscriptions: [],
      count: 0,
      page: 1,
      perPage: 20,

      loading: true,

      orderBy: {
        column: 'order',
        order: 'ASC',
      },

      selectedFilters: {
        searchString: '',
      },
    }
  }

  getExistingFiltersFromCookie = (cb) => {
    const selectedFilters = cookies.getJSON('TMFiltersSubscriptions')
    if (selectedFilters) {
      this.setState({selectedFilters: selectedFilters}, () => cb())
    } else {
      cb()
    }
  };

  setFilterCookie = (cb) => {
    // console.log('this.state.selectedFilters', this.state.selectedFilters)
    cookies.set('TMFiltersSubscriptions', this.state.selectedFilters, {expires: 0.2})
    cb()
  };

  componentDidMount() {
    this.getExistingFiltersFromCookie(() => {
      // this.getResource('subscriptions')
      // this.getResource('departments')
      this.getSubscriptions((sales) => this.setState({filteredSales: sales}))
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const _this = this
    if (prevState !== this.state && prevState.loaded) {
      if (this.state.forceUpdate !== prevState.forceUpdate) {
        _this.getSubscriptions()
      }
    }
  }

  getResource = (key) => {
    axios.get(`${config.apiUrl}/${key}`)
      .then(r => r.data.count ? this.setState({[key]: r.data.rows}) : console.log('no ', key))
      .catch(e => console.log('Cloud not fetch ', key, ' ',  e))
  };

  getSubscriptions = debounce((cb) => {
    // const _this = this;
    this.setState({loading: true})

    let queryString = '?perPage=1000'

    // Get ordering
    if (this.state.orderBy.column && this.state.orderBy.order) {
      queryString += `&order=${this.state.orderBy.column}&order=${this.state.orderBy.order}`
    }

    // get serachstring
    if (this.state.selectedFilters.searchString) {
      queryString += `&searchString=${this.state.selectedFilters.searchString}`
      queryString += `&searchKeys=name`
      queryString += `&searchKeys=botKey`
    }

    // Get all sales
    axios.get(`${config.apiUrl}/subscriptions${queryString}`)
      .then(r => {
        if (r.data) {
          this.setState({subscriptions: r.data.rows, count: r.data.count, loading: false})
        }
      }).catch(e => {
        console.log('error fetching sales', e)
      })
  }, 150);

  updateSelectedFilters = (filterKey, selectedFilters) => {
    const currentSelectedFilters = {...this.state.selectedFilters}
    currentSelectedFilters[filterKey] = selectedFilters
    this.setState({selectedFilters: currentSelectedFilters}, () => this.setFilterCookie(() => this.getSubscriptions()))
  };

  toggleOrderBy = (key) => {
    // 1. If column is not set OR not right key, then set it to key AND 'ASC'
    if (!this.state.orderBy.column || this.state.orderBy.column !== key) {
      const orderBy = {...this.state.orderBy}
      orderBy.column = key
      orderBy.order = 'asc'
      this.setState({orderBy: orderBy}, () => this.getSubscriptions())
    }
    // 2. Else if column is key but asc is set, then set desc
    else if (this.state.orderBy.column === key && this.state.orderBy.order === 'asc') {
      const orderBy = {...this.state.orderBy}
      orderBy.order = 'desc'
      this.setState({orderBy: orderBy}, () => this.getSubscriptions())
    }
    // 3. REMOVE ORDER
    else {
      this.setState({orderBy: {column: null, order: null}}, () => this.getSubscriptions())
    }
  };

  getColumnClass = (key) => {
    if (this.state.orderBy.column === key) {
      if (this.state.orderBy.order === 'asc') {
        return 'is-order-asc'
      } else {
        return 'is-order-desc'
      }
    }
    return ''
  };

  paginate = (e, key) => {
    e.preventDefault()
    let page = this.state.page
    if (typeof key === 'number') {
      page = key
    } else if (key === 'next') {
      page = page + 1
    } else if (key === 'previous') {
      page = page - 1
    }
    this.setState({page: page}, () => this.getSubscriptions())
  };

  render () {
    const {subscriptions, count} = this.state

    return (
       <main>
        <div className="main-header">
          <div className="tm-filters">
            <div className="filter-group">
              <label htmlFor="search_string">Søk (Navn/Key)</label>
              <input type="text" id="search_string" className="form-control" value={this.state.selectedFilters.searchString} onChange={e => this.updateSelectedFilters('searchString', e.target.value)} />
            </div>
            <div className="filter-group">
              <button onClick={e => this.props.dispatch(setModal({key: 'add-subscription'}))}>Ny prisplan</button>
            </div>
          </div>
        </div>

        <div className="main-body --wide-layout-temp-class">
          <div className="main-body__header">
            <h1>Viser {subscriptions.length} prisplaner</h1>
          </div>
          <div className={`tm-table h-has-loader ${this.state.loading ? 'is-loading' : 'is-done-loading'}`}>
            <div className="lds_w"><div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div>
            <div className="tm-table__header-row">
              <div className={`tm-table__cell -sortable ${this.getColumnClass('name')}`} onClick={() => this.toggleOrderBy('name')}><span className="cell-content">Navn</span></div>
              <div className={`tm-table__cell -sortable ${this.getColumnClass('botKey')}`} onClick={() => this.toggleOrderBy('botKey')}><span className="cell-content">Bot-nøkkel</span></div>
              <div className={`tm-table__cell -sortable ${this.getColumnClass('amount')}`} onClick={() => this.toggleOrderBy('amount')}><span className="cell-content">Kroner/mnd</span></div>
              <div className={`tm-table__cell -sortable ${this.getColumnClass('order')}`} onClick={() => this.toggleOrderBy('order')}><span className="cell-content">Rekkefølge</span></div>
              <div className={`tm-table__cell -sortable ${this.getColumnClass('active')}`} onClick={() => this.toggleOrderBy('active')}><span className="cell-content">Aktiv</span></div>
              <div className={`tm-table__cell -sortable ${this.getColumnClass('kidSafe')}`} onClick={() => this.toggleOrderBy('kidSafe')}><span className="cell-content">Trygg</span></div>
            </div>
            <div className="tm-table__body">
              {subscriptions.map((s) => {
                return (
                  <a className={`tm-table__row`}
                      key={s.id}
                      href={`/#/subscriptions/${s.id}`}>
                    <div className="tm-table__cell"><div className="cell-content">{s.name && s.name} {!s.name && 'Ukjent'}</div></div>
                    <div className="tm-table__cell"><div className="cell-content">{s.botKey && s.botKey} {!s.botKey && 'Ukjent'}</div></div>
                    <div className="tm-table__cell"><div className="cell-content">{s.amount && s.amount}</div></div>
                    <div className="tm-table__cell"><div className="cell-content">{s.order && s.order}</div></div>
                    <div className="tm-table__cell"><div className="cell-content">{s.active && 'Aktiv'} {!s.active && 'Ikke aktiv'}</div></div>
                    <div className="tm-table__cell"><div className="cell-content">{s.kidSafe && 'Trygg'} {!s.kidSafe && 'Ikke trygg'}</div></div>
                  </a>
                )
              })}
              {subscriptions.length === 0 &&
                <div>Ingen prisplaner med dette søket</div>
              }
            </div>
          </div>
          <div className="main-body__footer">
            <Pagination paginate={this.paginate.bind(this)} page={this.state.page} perPage={this.state.perPage} count={this.state.count} rows={this.state.subscriptions} />
          </div>
        </div>

      </main>
    )
  }
}

const mapStateToProps = state => {
  return {
    layout: state.layout
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubscriptionsListComponent)

